import type { FormSummaryJSONObject } from '@ikegps/core-api';
import { IkeRestObject } from './base';

export class IkeObjectFormSummary extends IkeRestObject<FormSummaryJSONObject> {
	className = 'FormSummary' as const;
	actionName = 'form.summary';
	object?: FormSummaryJSONObject;

	constructor() {
		super();
		this.cacheKeys['revision'] = true;
	}
}
